/*
  Amiy phone sign-in and checkout provider, shared by /pages/my-account, the header "Sign in" link,
  the pre-checkout OTP gate and the Buy it now fallback.

  Provider = Theme settings > Checkout & login (window.AMIY_CHECKOUT_PROVIDER):
  - 'otp_gate'       (PayU / Shopify checkout): phone + SMS OTP through the amiybook API; the
                      pre-checkout gate asks for it before checkout unless the customer is signed in.
  - 'razorpay_magic' : the OTP gate is not loaded (layout/theme.liquid); Razorpay Magic does login
                      and checkout. Buy it now goes through the cart's checkout button so Razorpay's
                      script takes it over; "Sign in" opens the Shopify account page.
*/
(function () {
  'use strict';

  var PROVIDER = window.AMIY_CHECKOUT_PROVIDER || 'otp_gate';
  var API_BASE = (window.PRECHECKOUT_API_URL || 'https://amiybook.netlify.app/.netlify/functions').replace(/\/$/, '');
  var ACCOUNT_KEY = 'amiy_account';
  var ACCOUNT_DAYS = 30;

  function digitsOnly(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function normalizePhone(value) {
    var d = digitsOnly(value);
    if (d.length === 12 && d.indexOf('91') === 0) d = d.slice(2);
    if (d.length === 11 && d.charAt(0) === '0') d = d.slice(1);
    if (d.length === 10 && /^[6-9]/.test(d)) return d;
    return null;
  }

  function account() {
    try {
      var data = JSON.parse(localStorage.getItem(ACCOUNT_KEY) || 'null');
      if (!data || !data.phone || !data.exp || Date.now() > data.exp) {
        localStorage.removeItem(ACCOUNT_KEY);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  // name is optional (the pre-checkout gate has no name field): keep the saved name for the same phone.
  function remember(phone, name) {
    if (!phone) return;
    var prev = account();
    if (!name && prev && prev.phone === phone) name = prev.name;
    try {
      localStorage.setItem(
        ACCOUNT_KEY,
        JSON.stringify({ phone: phone, name: name || '', exp: Date.now() + ACCOUNT_DAYS * 24 * 60 * 60 * 1000 })
      );
    } catch (e) {
      /* ignore */
    }
    updateHeader();
  }

  function signOut() {
    try {
      localStorage.removeItem(ACCOUNT_KEY);
      sessionStorage.removeItem('amiy_precheckout_ok');
    } catch (e) {
      /* ignore */
    }
    updateHeader();
  }

  function apiPost(path, payload) {
    return fetch(API_BASE + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        return { ok: res.ok, status: res.status, data: data };
      });
    });
  }

  // Sends the SMS code, or returns data.proceed === true when the API needs no code for this number.
  function requestOtp(phone) {
    return apiPost('/storefront-checkout-gate', { phone: phone });
  }

  function verifyOtp(phone, code) {
    return apiPost('/storefront-verify-otp', { phone: phone, code: code });
  }

  // Signed in: "Hi! <first name>" (older sign-ins without a name: "My account"), and the Shopify
  // account icon ([data-amiy-account-icon]) is hidden so the greeting sits next to search.
  function updateHeader() {
    var acc = PROVIDER === 'otp_gate' ? account() : null;
    var first = acc && acc.name ? String(acc.name).split(' ')[0] : '';
    var here = window.location.pathname + window.location.search;
    document.querySelectorAll('[data-amiy-signin]').forEach(function (link) {
      if (PROVIDER === 'razorpay_magic' && link.dataset.accountUrl) link.href = link.dataset.accountUrl;
      // Signed out: /pages/my-account?return_to=<this page> so sign-in brings the customer back here.
      else if (PROVIDER === 'otp_gate') {
        link.href = !acc && here.indexOf('/pages/my-account') !== 0
          ? '/pages/my-account?return_to=' + encodeURIComponent(here)
          : '/pages/my-account';
      }
      var label = link.querySelector('.navtext');
      if (!label) return;
      label.textContent = !acc ? 'Sign in' : first ? 'Hi! ' + first : link.dataset.signedLabel || 'My account';
      label.title = acc && acc.name ? acc.name : '';
    });
    document.querySelectorAll('[data-amiy-account-icon]').forEach(function (el) {
      el.style.display = acc ? 'none' : '';
    });
  }

  // Razorpay mode: add the item, then press a cart checkout button so Razorpay Magic's script handles it.
  function buyNowViaCart(variantId, qty) {
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] }),
    }).then(function () {
      var form = document.createElement('form');
      form.method = 'post';
      form.action = '/cart';
      form.style.display = 'none';
      var btn = document.createElement('button');
      btn.type = 'submit';
      btn.name = 'checkout';
      btn.value = 'checkout';
      form.appendChild(btn);
      document.body.appendChild(form);
      btn.click();
    });
  }

  window.AmiyAuth = {
    provider: PROVIDER,
    normalizePhone: normalizePhone,
    account: account,
    remember: remember,
    signOut: signOut,
    requestOtp: requestOtp,
    verifyOtp: verifyOtp,
    buyNowViaCart: buyNowViaCart,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeader);
  } else {
    updateHeader();
  }
})();
